import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

function Footer({ cartCount: propCartCount = 0, onSearchClick }) {
  const dealerId = localStorage.getItem("LoginNumber");
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Cart count state - initialize from localStorage
  const [cartCount, setCartCount] = useState(() => {
    const savedCount = localStorage.getItem('cart_count');
    return savedCount ? parseInt(savedCount) : propCartCount;
  });

  // Listen for cart update events
  useEffect(() => {
    const handleCartUpdate = (event) => {
      if (event.detail && event.detail.cartCount !== undefined) {
        setCartCount(event.detail.cartCount);
      }
    };

    window.addEventListener('cart-updated', handleCartUpdate);
    
    // Also listen for storage changes
    const handleStorageChange = (e) => {
      if (e.key === 'cart_count') {
        setCartCount(e.newValue ? parseInt(e.newValue) : 0);
      }
    };
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('cart-updated', handleCartUpdate);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  // Also sync from local_cart for backward compatibility
  useEffect(() => {
    const updateFromLocalCart = () => {
      try {
        const cart = localStorage.getItem("local_cart");
        const items = cart ? JSON.parse(cart) : [];
        const count = items.filter((item) => item.product_quantity > 0).length;
        if (count > 0) {
          setCartCount(count);
          localStorage.setItem('cart_count', count.toString());
        }
      } catch (error) {
        console.error("Error reading local_cart:", error);
      }
    };
    
    updateFromLocalCart();
    window.addEventListener("storage", updateFromLocalCart);
    return () => window.removeEventListener("storage", updateFromLocalCart);
  }, []);

  const displayCartCount = cartCount || propCartCount;

  // Detect screen size
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Handle search icon click
  const handleSearchClick = () => {
    if (location.pathname.startsWith("/AddProduct") && onSearchClick) {
      onSearchClick();
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
      const searchInput = document.querySelector(".search-box input");
      if (searchInput) {
        searchInput.focus();
      }
    }
  };

  // Theme colors
  const accentColor = "rgb(219, 68, 55)";
  const backgroundColor = "#ffffff";
  const textColor = "#000000";
  const textSecondary = "#666666";
  const borderColor = "#e0e0e0";

  // ========== MOBILE FOOTER ==========
  if (isMobile) {
    if (location.pathname.startsWith("/AddProduct")) {
      return (
        <>
          <div
            id="footer-bar"
            className="footer-bar-1"
            style={{ 
              background: backgroundColor,
              borderTop: `1px solid ${borderColor}`,
              boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.05)"
            }}
          >
            {/* <Link
              to="/scan"
              className={location.pathname === "/" ? "active-nav" : ""}
              style={{ paddingTop: "10px" }}
            >
              <img
                src="./ScanQR.png"
                alt="Product"
                style={{
                  maxWidth: "90px",
                  objectFit: "contain",
                  marginBottom: "0px",
                  borderRadius: "10px",
                }}
              />
            </Link> */}

            <Link
              to="/Mycart"
              className={location.pathname === "/Mycart" ? "active-nav" : ""}
              style={{ paddingTop: "10px" }}
            >
              <img
                src="./1000265847.jpg"
                alt="Product"
                style={{
                  maxWidth: "90px",
                  marginBottom: "0px",
                  borderRadius: "10px",
                }}
              />
            </Link>
          </div>
          <div
            id="footer-bar"
            className="footer-bar-1"
            style={{ 
              background: backgroundColor,
              borderTop: `1px solid ${borderColor}`,
              boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.05)"
            }}
          >
            <Link
              to="/"
              className={location.pathname === "/" ? "active-nav" : ""}
              style={{ color: textColor }}
            >
              <i className="fa fa-home" style={{ color: textSecondary }}></i>
              <span style={{ color: textColor }}>Home</span>
            </Link>
            <Link 
              to="/AddProduct" 
              onClick={handleSearchClick}
              style={{ color: textColor }}
            >
              <div style={{ position: "relative", display: "inline-block" }}>
                <i
                  className="fa fa-search rounded-s"
                  aria-hidden="true"
                  style={{ fontSize: "18px", color: textSecondary }}
                ></i>
              </div>
              <span style={{ color: textColor }}>Search Products</span>
            </Link>

            <Link
              to="/MyOrderds"
              className={location.pathname === "/MyOrderds" ? "active-nav" : ""}
              alt="QR Scan"
              style={{ width: "18px", color: textColor }}
              loading="lazy"
            >
              <i className="fa fa-cubes" aria-hidden="true" style={{ color: textSecondary }}></i>
              <span style={{ color: textColor }}>My Orders</span>
            </Link>
            <Link to="/Mycart" style={{ color: textColor }}>
              <div style={{ position: "relative", display: "inline-block" }}>
                <i
                  className="fa fa-shopping-cart rounded-s"
                  aria-hidden="true"
                  style={{ fontSize: "18px", color: textSecondary }}
                ></i>
                {displayCartCount > 0 && (
                  <span
                    style={{
                      position: "absolute",
                      top: "-5px",
                      right: "-8px",
                      backgroundColor: accentColor,
                      color: "white",
                      borderRadius: "50%",
                      width: "20px",
                      height: "20px",
                      fontSize: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: "bold",
                    }}
                  >
                    {displayCartCount}
                  </span>
                )}
              </div>
              <span style={{ color: textColor }}>My Cart</span>
            </Link>
            <Link
              to="/More"
              className={location.pathname === "/More" ? "active-nav" : ""}
              style={{ color: textColor }}
            >
              <i className="fa fa-list" aria-hidden="true" style={{ color: textSecondary }}></i>
              <span style={{ color: textColor }}>More</span>
            </Link>
          </div>
        </>
      );
    } else {
      return (
        <div
          id="footer-bar"
          className="footer-bar-1"
          style={{ 
            background: backgroundColor,
            borderTop: `1px solid ${borderColor}`,
            boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.05)"
          }}
        >
          <Link
            to="/"
            className={location.pathname === "/" ? "active-nav" : ""}
            style={{ color: textColor }}
          >
            <i className="fa fa-home" style={{ color: textSecondary }}></i>
            <span style={{ color: textColor }}>Home</span>
          </Link>
          <Link
            to="/AddProduct"
            className={
              location.pathname.startsWith("/AddProduct") ? "active-nav" : ""
            }
            onClick={handleSearchClick}
            style={{ color: textColor }}
          >
            <div style={{ position: "relative", display: "inline-block" }}>
              <i
                className="fa fa-archive rounded-s"
                aria-hidden="true"
                style={{ fontSize: "22px", color: textSecondary }}
              ></i>
            </div>
            <span style={{ color: textColor }}>All Products</span>
          </Link>
          <Link
            to="/MyOrderds"
            className={location.pathname === "/MyOrderds" ? "active-nav" : ""}
            style={{ color: textColor }}
          >
            <i className="fa fa-cubes" aria-hidden="true" style={{ color: textSecondary }}></i>
            <span style={{ color: textColor }}>My Orders</span>
          </Link>
          <Link to="/Mycart" style={{ color: textColor }}>
            <div style={{ position: "relative", display: "inline-block" }}>
              <i
                className="fa fa-shopping-cart rounded-s"
                aria-hidden="true"
                style={{ fontSize: "18px", color: textSecondary }}
              ></i>
              {displayCartCount > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: "-5px",
                    right: "-8px",
                    backgroundColor: accentColor,
                    color: "white",
                    borderRadius: "50%",
                    width: "20px",
                    height: "20px",
                    fontSize: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                  }}
                >
                  {displayCartCount}
                </span>
              )}
            </div>
            <span style={{ color: textColor }}>My Cart</span>
          </Link>

          <Link
            to="/More"
            className={location.pathname === "/More" ? "active-nav" : ""}
            style={{ color: textColor }}
          >
            <i className="fa fa-list" aria-hidden="true" style={{ color: textSecondary }}></i>
            <span style={{ color: textColor }}>More</span>
          </Link>
        </div>
      );
    }
  }

  // ========== WEB FOOTER ==========
  return (
    <div className="web-footer">
      <style jsx>{`
        .web-footer {
          background: ${backgroundColor};
          border-top: 1px solid ${borderColor};
          padding: 30px 0;
          margin-top: auto;
          padding-bottom: calc(30px + env(safe-area-inset-bottom));
          position: relative;
        }

        .footer-content {
          max-width: 100%;
          margin: 0 auto;
          padding: 0 40px;
        }

        .footer-sections {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 40px;
          margin-bottom: 40px;
        }

        .footer-section h4 {
          color: ${accentColor};
          font-size: 18px;
          margin-bottom: 20px;
          font-weight: 600;
          position: relative;
          padding-bottom: 10px;
        }

        .footer-section h4::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 40px;
          height: 2px;
          background: ${accentColor};
        }

        .footer-links {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .footer-links li {
          margin-bottom: 12px;
        }

        .footer-links a {
          color: ${textSecondary};
          text-decoration: none;
          transition: all 0.3s ease;
          font-size: 14px;
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }

        .footer-links a:hover {
          color: ${accentColor};
          transform: translateX(5px);
        }

        .footer-links a::before {
          content: '›';
          color: ${accentColor};
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .footer-links a:hover::before {
          opacity: 1;
        }

        .footer-contact p {
          color: ${textSecondary};
          margin-bottom: 15px;
          font-size: 14px;
          display: flex;
          align-items: flex-start;
          line-height: 1.5;
        }

        .footer-contact i {
          color: ${accentColor};
          margin-right: 12px;
          width: 16px;
          margin-top: 2px;
          flex-shrink: 0;
        }

        .footer-contact p[style*="cursor: pointer"] {
          cursor: pointer;
          transition: color 0.3s ease;
        }

        .footer-contact p[style*="cursor: pointer"]:hover {
          color: ${accentColor};
        }

        .footer-bottom {
          border-top: 1px solid ${borderColor};
          padding-top: 25px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .footer-copyright {
          color: ${textSecondary};
          font-size: 14px;
        }

        .footer-social {
          display: flex;
          align-items: center;
          gap: 20px;
        }

        .footer-social h4 {
          color: ${textColor};
          font-size: 16px;
          margin: 0;
          font-weight: 600;
        }

        .social-links {
          display: flex;
          gap: 15px;
          margin-left: 15px;
        }

        .social-link {
          color: ${textSecondary};
          font-size: 16px;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          border: 1px solid ${borderColor};
        }

        .social-link:hover {
          color: white;
          background: ${accentColor};
          border-color: ${accentColor};
          transform: translateY(-2px);
        }

        .quick-nav {
          display: flex;
          gap: 20px;
          margin-top: 15px;
        }

        .quick-nav a {
          color: ${textSecondary};
          text-decoration: none;
          font-size: 14px;
          transition: color 0.3s ease;
        }

        .quick-nav a:hover {
          color: ${accentColor};
        }

        /* Active state for mobile footer links */
        #footer-bar .active-nav i {
          color: ${accentColor} !important;
        }
        
        #footer-bar .active-nav span {
          color: ${accentColor} !important;
          font-weight: 600;
        }

        @media (max-width: 1024px) {
          .footer-sections {
            grid-template-columns: repeat(2, 1fr);
            gap: 30px;
          }
          
          .footer-content {
            padding: 0 20px;
          }
        }

        @media (max-width: 768px) {
          .web-footer {
            display: none;
          }
        }

        @media (max-width: 480px) {
          .footer-sections {
            grid-template-columns: 1fr;
          }

          .footer-bottom {
            flex-direction: column;
            gap: 20px;
            text-align: center;
          }
          
          .footer-social {
            flex-direction: column;
            gap: 15px;
          }
          
          .social-links {
            margin-left: 0;
          }
        }

        /* Mobile footer styling */
        #footer-bar {
          display: flex;
          justify-content: space-around;
          align-items: center;
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          height: 70px;
          z-index: 1000;
          padding-bottom: env(safe-area-inset-bottom);
        }

        #footer-bar a {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          height: 100%;
          transition: all 0.3s ease;
        }

        #footer-bar a:hover {
          background: rgba(219, 68, 55, 0.05);
        }

        #footer-bar i {
          font-size: 20px;
          margin-bottom: 4px;
        }

        #footer-bar span {
          font-size: 11px;
          font-weight: 500;
        }
      `}</style>

      <div className="footer-content">
        <div className="footer-sections">
          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="footer-contact">
              <p>
                <i className="fa fa-user"></i> AG HOME DECOR MORBI
              </p>

              {/* Phone Click */}
              <p
                onClick={() => (window.location.href = "tel:+918780378668")}
                style={{ cursor: "pointer" }}
              >
                <i className="fa fa-phone"></i> +91 87803 78668
              </p>

              {/* Google Maps Click */}
              <p
                onClick={() =>
                  window.open(
                    "https://maps.app.goo.gl/z4JwoschKLdqtqiaA",
                    "_blank"
                  )
                }
                style={{ cursor: "pointer" }}
              >
                <i className="fa fa-map-marker-alt"></i> Morbi - 2, Lalpar,
                Bhadiyad Part, Gujarat 363642
              </p>

            
            </div>
          </div>
          
          {/* Quick Links */}
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/AddProduct">All Products</Link>
              </li>
              <li>
                <Link to="/MyDevice">My Device</Link>
              </li>
             
            </ul>
          </div>

          {/* Orders & Support */}
          <div className="footer-section">
            <h4>Orders & Support</h4>
            <ul className="footer-links">
              <li>
                <Link to="/MyOrderds">My Order</Link>
              </li>
              <li>
                <Link to="/Mycart">My Selection</Link>
              </li>
              <li>
                <Link to="/MyTransaction">My Transactions</Link>
              </li>
             
            </ul>
          </div>

          {/* Account */}
          <div className="footer-section">
            <h4>Account</h4>
            <ul className="footer-links">
              <li>
                <Link to="/UpdateProdile">Edit Profile</Link>
              </li>
              <li>
                <Link to="/UpdateBankDetails">Bank Details</Link>
              </li>
             
              <li>
                <Link to="/Complain">Complaints</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-social">
            <h4 style={{ color: textColor }}>
              The Fusion of Four, A Design Revolution
            </h4>
            <div className="social-links">
              <a
                href="https://www.facebook.com/p/AGHome-Decore-Poster-Tiles-Morbi-61563099224817/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://www.instagram.com/ag_home_decor_tiles_morbi_/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
          <div className="footer-copyright">
            © {new Date().getFullYear()} AG Home Decor. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;